import gql from 'graphql-tag'

export const GET_ROOM_CATEGORIES_PRICES_PAGINATION_QUERY = gql`
  query GetRoomCategoriesPricesPagination (
    $skip: Int!
    $take: Int!
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getRoomCategoriesPrices (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        prices {
          value
        }
      }
    }
  }
`
